import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar, Button } from '../components';
import { useUser, useAuth } from '../context';
import discoBall from '../assets/img/disco-ball.svg';

/**
 * Initialize Credential Page (Screen 04A)
 * Intro screen before credential builder
 * Design: Inside theme - light background, operational/dense design
 */
export default function InitializeCredentialPage() {
  const navigate = useNavigate();
  const { profile, walletBalance } = useUser();
  const { logout } = useAuth();

  const handleInitialize = () => {
    navigate('/credential-builder');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50/50">
      <Navbar
        user={profile}
        walletBalance={walletBalance}
        onLogout={handleLogout}
        onLogoClick={() => navigate('/')}
      />

      <main className="max-w-2xl mx-auto px-4 py-16">
        {/* Header */}
        <div className="text-center mb-12">
          <img src={discoBall} alt="Disco ball" className="w-20 h-20 mx-auto mb-8" />
          <h1 className="font-mono text-3xl md:text-4xl font-bold uppercase tracking-wider text-black mb-6 flex items-center justify-center gap-3">
            CREATE PARTY RESUME
            <img src={discoBall} alt="" className="w-8 h-8 md:w-10 md:h-10" />
          </h1>
        </div>

        {/* Info card */}
        <div className="border-2 border-black bg-white p-8 mb-8">
          <p className="font-mono text-sm leading-relaxed text-gray-700 mb-6">
            Before entering rooms, hosts need to know who is showing up. Your Party Resume is your identity in the party world.
          </p>

          <div className="border-t-2 border-black pt-6 space-y-4">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 border-2 border-black flex items-center justify-center flex-shrink-0">
                <span className="font-mono text-sm font-bold">1</span>
              </div>
              <div>
                <h3 className="font-mono text-sm font-bold uppercase tracking-wider text-black mb-1">
                  UPLOAD YOUR PHOTO
                </h3>
                <p className="font-mono text-xs text-gray-600">
                  Hosts want to see real faces, not avatars or logos.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 border-2 border-black flex items-center justify-center flex-shrink-0">
                <span className="font-mono text-sm font-bold">2</span>
              </div>
              <div>
                <h3 className="font-mono text-sm font-bold uppercase tracking-wider text-black mb-1">
                  SET YOUR DISPLAY NAME
                </h3>
                <p className="font-mono text-xs text-gray-600">
                  How you want to be known in the community.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 border-2 border-black flex items-center justify-center flex-shrink-0">
                <span className="font-mono text-sm font-bold">3</span>
              </div>
              <div>
                <h3 className="font-mono text-sm font-bold uppercase tracking-wider text-black mb-1">
                  DESCRIBE YOUR VIBE
                </h3>
                <p className="font-mono text-xs text-gray-600">
                  Tell hosts what you bring to the party.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Initialize button */}
        <div className="text-center">
          <Button
              variant="primary"
              size="lg"
              onClick={handleInitialize}
              fullWidth
          >
            CONTINUE
          </Button>
        </div>
      </main>
    </div>
  );
}
